div
  v-row
    v-col(cols="12")
      v-text-field(
        v-model="address.address"
        :label="$t('patient.demographic.mailingAddress')"
        :rules="[address.validCheck('address')]"
      )
  v-row
    v-col(cols="12" md="4")
      v-text-field(
        v-model="address.city"
        :label="$t('patient.demographic.city')"
        :rules="[address.validCheck('city')]"
      )
    v-col(cols="12" md="4")
      v-text-field(
        v-model="address.state"
        :label="$t('patient.demographic.state')"
        :rules="[address.validCheck('state')]"
      )
    v-col(cols="12" md="4")
      v-text-field(
        v-model="address.zip"
        :label="$t('patient.demographic.zip')"
        :rules="[address.validCheck('zip')]"
      )
